import { render, staticRenderFns } from "./FeatureIntroRevealer.vue?vue&type=template&id=08dc044c&scoped=true"
import script from "./FeatureIntroRevealer.vue?vue&type=script&lang=js"
export * from "./FeatureIntroRevealer.vue?vue&type=script&lang=js"
import style0 from "./FeatureIntroRevealer.vue?vue&type=style&index=0&id=08dc044c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc044c",
  null
  
)

export default component.exports